import { Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import { Fragment } from 'react';

import { useNotificationStore } from '../store';

const icons = {
  info: (
    <InformationCircleIcon className="information-icon " aria-hidden="true" />
  ),
  success: <CheckCircleIcon className="check-circle-icon" aria-hidden="true" />,
  warning: (
    <ExclamationCircleIcon className="exclamation-icon" aria-hidden="true" />
  ),
  error: <XCircleIcon className="x-circle-icon" aria-hidden="true" />,
};

export const Notifications = () => {
  const { notifications, dismissNotification } = useNotificationStore();

  setTimeout(() => {
    notifications.map((notification) => dismissNotification(notification.id));
  }, 5000);

  return (
    <div
      aria-live="assertive"
      className="notifications-main-container notification_zindex"
      // style={{ zIndex: '99999' }}
    >
      {notifications &&
        notifications.map((notification, index) => (
          <div key={index} className="notifications-transition-container">
            <Transition
              show={true}
              as={Fragment}
              enter="enter-transition"
              enterFrom="enter-from-transition"
              enterTo="enter-to-transition"
              leave="leave-transition"
              leaveFrom="leave-from-transition "
              leaveTo="leave-to-transition"
            >
              <div className="notification-item-container">
                <div
                  className="notification-alert"
                  role="alert"
                  aria-label={notification.title}
                >
                  <div className="notification-item">
                    <div className="notification-type">
                      {icons[notification.type]}
                    </div>
                    <div className="notification-title-message-container">
                      <p className="notification-title-text ">
                        {notification.title}
                      </p>
                      <p className="notification-message-text">
                        {notification.message}
                      </p>
                      <p className="notification-message-text">
                        {notification.action}
                      </p>
                    </div>
                    <div className="notification-close-button-container">
                      <button
                        className="notification-close-button"
                        onClick={() => {
                          dismissNotification(notification.id);
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XMarkIcon
                          className="notification-close-icon"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        ))}
    </div>
  );
};
